import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Socials from "../components/about/socials";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/about.css";

const About = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "about");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`About | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="about" />
				<div className="content-wrapper">
					<div className="about-logo-container">
						<div className="about-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="about-container">
						<div className="about-main">
							<div className="about-right-side">
								<div className="title about-title">
									{INFO.about.title}
								</div>

								<div className="subtitle about-subtitle">
									I'm a skilled frontend developer
									specializing in ReactJS, Tailwind CSS,
									Bootstrap, NextJS, and Firebase. With a
									passion for problem-solving and adherence to
									industry standards, I bring a unique blend
									of technical expertise and creative flair.
									Also, I have worked on some freelancing
									projects:&nbsp;
									<a
										href="https://www.triwize.com/"
										target="_blank"
										rel="noreferrer"
									>
										Triwize
									</a>
									&nbsp;and&nbsp;
									<a
										href="https://www.transitco.in/"
										target="_blank"
										rel="noreferrer"
									>
										Transit
									</a>
									. <br />
									Beyond coding, I'm a poet and singer,
									contributing as a core team member in my
									college tech club. My commitment lies in
									delivering high-quality, user-centric
									solutions and embracing new challenges to
									continually grow as a developer.
								</div>
							</div>

							<div className="about-left-side">
								<div className="about-image-container">
									<div className="about-image-wrapper">
										<img
											src="about.jpg"
											alt="about"
											className="about-image"
										/>
									</div>
								</div>

								<div className="about-socials">
									<Socials />
								</div>
							</div>
						</div>
						<div className="about-socials-mobile">
							<Socials />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default About;
